import styles from "./index.module.scss";
import classNames from "classnames";
import {
  Checkbox,
  Input,
  Collapse,
  Tag,
  DatePicker,
  Select,
  Tabs,
  Affix,
  Pagination,
  Masonry,
  Spin,
  Empty,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { sidebar, dataList } from "@/apis/discover";
import { useSearchParams, useNavigate } from "react-router-dom";
import intl from "react-intl-universal";
import ResourceCard from "@/components/ResourceCard";

const CheckboxGroup = Checkbox.Group;
const { RangePicker } = DatePicker;
const getFilterKey = (menuBoxName, value) => `${menuBoxName}@${value}`;

const dataMap = {
  OpenData: {
    title: "Open Data",
    desc: "Open Data",
    children: [
      {
        title: "Open Geospatial Data",
        type: "OpenGeospatialData",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
      {
        title: "Open AI Training Data",
        type: "OpenAITrainingData",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
      {
        title: "Open Data Services",
        type: "OpenDataServices",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
    ],
  },
  OpenTools: {
    title: "Open Tools",
    desc: "Open Tools",
    children: [
      {
        title: "Open Codes",
        type: "OpenCodes",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
      {
        title: "Open Executables",
        type: "OpenExecutables",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
      {
        title: "Open SDKs",
        type: "OpenSDKs",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
      {
        title: "Open Container Images",
        type: "OpenContainerImages",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
      {
        title: "Open Process Services",
        type: "OpenProcessServices",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
    ],
  },
  OpenDocs: {
    title: "Open Docs",
    desc: "Open Docs",
    children: [
      {
        title: "Specifications Docs",
        type: "OpenSpecifications",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
      {
        title: "Technical Docs",
        type: "TechnicalDocs",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
      {
        title: "Development Guidelines",
        type: "DevelopmentGuidelines",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
      {
        title: "Training & Course Materials",
        type: "TrainingCourseMaterials",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
    ],
  },
  OpenApps: {
    title: "Open Apps",
    desc: "Open APPs",
    children: [
      {
        title: "Open Web Apps",
        type: "OpenWebApps",
        desc: "放数据资源 (Open Data) 是指任何人都可以自由访问",
      },
    ],
  },
};
const OpenData = () => {
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [listTree, setListTree] = useState([]);
  const [keywords, setKeywords] = useState("");
  const [timeRange, setTimeRange] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [total, setTotal] = useState(0);
  const requestedType = searchParams.get("type") || "All";
  // Older category links pass a first-level type; query the initial child tab instead.
  const secondType = dataMap[requestedType]?.children[0].type || requestedType;
  const title = searchParams.get("title") || (dataMap[requestedType] ? requestedType : "All");
  const [params, setparams] = useState({
    currentPage: 1,
    pageSize: 10,
  });
  const [itemData, setItemData] = useState([]);
  const [defaultActiveKey, setDefaultActiveKey] = useState([]);
  const [checkboxFilters, setCheckboxFilters] = useState([]);
  const [selectedMenuBoxName, setSelectedMenuBoxName] = useState();
  const [selectedMenuEntryValues, setSelectedMenuEntryValues] = useState([]);

  const handleKeyDown = (e) => {
    if (e.keyCode === 13) {
      if (params.currentPage === 1 && params.pageSize === 10) {
        getList();
        return;
      }

      setparams({
        currentPage: 1,
        pageSize: 10,
      });
    }
  };
  const getSide = useCallback(() => {
    sidebar({
      secondType: secondType === "All" ? "" : secondType,
    })
      .then((res) => {
        setListTree(res.data?.menuBoxes || []);
      })
      .catch(() => {});
  }, [secondType]);

  useEffect(() => {
    if (secondType) {
      setCheckboxFilters([]);
      setSelectedMenuBoxName(undefined);
      setSelectedMenuEntryValues([]);
      getSide();
      setparams((prev) =>
        prev.currentPage === 1
          ? prev
          : {
              ...prev,
              currentPage: 1,
            },
      );
    }
  }, [getSide, secondType]);

  const selectPro = (list) => {
    const arr = list.map((item) => {
      const strArr = item.split("@");
      return {
        menuBoxName: strArr[0],
        value: strArr[1],
      };
    });
    setCheckboxFilters(arr);
    if (arr.length === 0) {
      setSelectedMenuBoxName(undefined);
      setSelectedMenuEntryValues([]);
    } else {
      const menuBoxNames = [...new Set(arr.map((item) => item.menuBoxName))];
      if (selectedMenuBoxName && menuBoxNames.includes(selectedMenuBoxName)) {
        setSelectedMenuEntryValues(
          arr.filter((item) => item.menuBoxName === selectedMenuBoxName).map((item) => item.value),
        );
      } else if (menuBoxNames.length === 1) {
        setSelectedMenuBoxName(menuBoxNames[0]);
        setSelectedMenuEntryValues(
          arr.filter((item) => item.menuBoxName === menuBoxNames[0]).map((item) => item.value),
        );
      } else {
        setSelectedMenuBoxName(undefined);
        setSelectedMenuEntryValues([]);
      }
    }
    setparams((prev) =>
      prev.currentPage === 1
        ? prev
        : {
            ...prev,
            currentPage: 1,
          },
    );
  };

  const handleMenuBoxChange = (value) => {
    if (selectedMenuBoxName && selectedMenuEntryValues.length > 0) {
      setCheckboxFilters((prev) => prev.filter((item) => item.menuBoxName !== selectedMenuBoxName));
    }

    setSelectedMenuBoxName(value);
    setSelectedMenuEntryValues(
      value
        ? checkboxFilters.filter((item) => item.menuBoxName === value).map((item) => item.value)
        : [],
    );
    if (value) {
      setDefaultActiveKey((prev) => (prev.includes(value) ? prev : [...prev, value]));
    }
    setparams((prev) =>
      prev.currentPage === 1
        ? prev
        : {
            ...prev,
            currentPage: 1,
          },
    );
  };

  const handleMenuEntryChange = (values) => {
    if (!selectedMenuBoxName) {
      return;
    }

    const nextValues = values || [];
    setSelectedMenuEntryValues(nextValues);
    setCheckboxFilters((prev) => {
      const next = prev.filter((item) => item.menuBoxName !== selectedMenuBoxName);
      return [
        ...next,
        ...nextValues.map((value) => ({
          menuBoxName: selectedMenuBoxName,
          value,
        })),
      ];
    });
    setparams((prev) =>
      prev.currentPage === 1
        ? prev
        : {
            ...prev,
            currentPage: 1,
          },
    );
  };

  const updateData = (id, flag) => {
    setDataSource(
      dataSource.map((item) => {
        if (item.resourceUuid === id) {
          return {
            ...item,
            isFavorite: flag,
            collectTimes: flag ? item.collectTimes + 1 : item.collectTimes - 1,
          };
        } else {
          return item;
        }
      }),
    );
  };
  useEffect(() => {
    if (listTree.length) {
      setItemData(
        listTree.map((item) => {
          return {
            key: item.name,
            label: item.name,
            children: (
              <div className={classNames(styles.groupBox)} key={item.name}>
                {item.menuEntries.map((son) => {
                  return (
                    <div key={son.id}>
                      <Checkbox className={styles.checkBox} value={`${item.name}@${son.id}`}>
                        {son.name}
                      </Checkbox>
                      <Tag className={styles.tagBox} color="magenta" variant="outlined">
                        {son.count}
                      </Tag>
                    </div>
                  );
                })}
              </div>
            ),
          };
        }),
      );
      setDefaultActiveKey(listTree.map((item) => item.name));
    } else {
      setItemData([]);
      setDefaultActiveKey([]);
    }
  }, [listTree]);

  const changeCollapse = (e) => {
    setDefaultActiveKey(e);
  };

  const filterBySidebarParams = useMemo(() => {
    return checkboxFilters.filter((item, index, list) => {
      return (
        list.findIndex(
          (target) => target.menuBoxName === item.menuBoxName && target.value === item.value,
        ) === index
      );
    });
  }, [checkboxFilters]);

  const getList = useCallback(() => {
    setLoading(true);
    dataList({
      secondType: secondType !== "All" ? secondType : "",
      filterBySidebarParams: filterBySidebarParams,
      keywords: keywords,
      startTime: timeRange ? timeRange[0] : "",
      endTime: timeRange ? timeRange[1] : "",
      pageParam: params,
    })
      .then((res) => {
        setLoading(false);
        setDataSource(res.data.records || []);
        setTotal(res.data.total || 0);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [filterBySidebarParams, keywords, params, secondType, timeRange]);
  const changeTab = (e) => {
    const searchParams = new URLSearchParams(decodeURIComponent(window.location.search));
    searchParams.set("type", e);
    navigate({ search: searchParams.toString() });
  };

  useEffect(() => {
    getList();
  }, [getList]);

  const selectedMenuBox = listTree.find((item) => item.name === selectedMenuBoxName);
  const menuBoxOptions = listTree.map((item) => ({
    label: item.name,
    value: item.name,
  }));
  const menuEntryOptions = (selectedMenuBox?.menuEntries || []).map((item) => ({
    label: item.name,
    value: item.id,
  }));
  const checkedFilterValues = useMemo(
    () => checkboxFilters.map((item) => getFilterKey(item.menuBoxName, item.value)),
    [checkboxFilters],
  );

  return (
    <div className={classNames(styles.openDataWrap)}>
      {title !== "All" && title ? (
        <div className={styles.bannerWrap}>
          <div className={styles.bannerContent}>
            <h1>{intl.get(`Header.${dataMap[title].title}`)}</h1>
            <span>{intl.get(`Discover.${dataMap[title].desc}`)}</span>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="container">
        {secondType !== "All" ? (
          <Affix offsetTop={80}>
            <Tabs
              activeKey={secondType}
              onChange={changeTab}
              style={{ background: "#fff" }}
              centered
              size="large"
              indicator={{
                size: 150,
              }}
              tabBarGutter={120}
              items={dataMap[title].children.map((item) => {
                return {
                  label: <span style={{ fontSize: 22 }}>{intl.get(`Header.${item.title}`)}</span>,
                  key: item.type,
                };
              })}
            ></Tabs>
          </Affix>
        ) : (
          ""
        )}
        <Spin spinning={loading} tip={intl.get("loading")}>
          <div className={classNames(styles.contentBoxWrap, "flex_box")}>
            <div
              style={{ top: secondType === "All" ? "95px" : "170px" }}
              className={styles.searchLeft}
            >
              <div>
                <div className={styles.filterRow}>
                  <Select
                    allowClear
                    className={styles.filterTypeSelect}
                    placeholder={intl.get("Filter Field")}
                    value={selectedMenuBoxName}
                    onChange={handleMenuBoxChange}
                    options={menuBoxOptions}
                  />
                  <Select
                    showSearch
                    mode="multiple"
                    allowClear
                    className={styles.filterValueSelect}
                    placeholder={intl.get("Select Filter Values")}
                    value={selectedMenuEntryValues}
                    onChange={handleMenuEntryChange}
                    options={menuEntryOptions}
                    maxTagCount={1}
                    filterOption={(input, option) =>
                      (option?.label || "").toLowerCase().includes(input.toLowerCase())
                    }
                    // disabled={!selectedMenuBoxName}
                  />
                </div>
                <Input
                  onKeyDown={handleKeyDown}
                  placeholder={intl.get("Search Resources By Title")}
                  onChange={(e) => setKeywords(e.target.value)}
                  prefix={<SearchOutlined />}
                />
                <RangePicker
                  onChange={(_e, date) => {
                    setTimeRange(date);
                  }}
                  className={styles.searchBox}
                  placeholder={[intl.get("Start Date"), intl.get("End Date")]}
                />
                <CheckboxGroup
                  className={styles.searchBox}
                  onChange={selectPro}
                  value={checkedFilterValues}
                >
                  <Collapse
                    style={{ width: "100%" }}
                    activeKey={defaultActiveKey}
                    onChange={changeCollapse}
                    size="small"
                    items={itemData}
                  />
                </CheckboxGroup>
              </div>
            </div>
            <div
              style={{ marginTop: secondType === "All" ? "15px" : "0" }}
              className={classNames(styles.contentRight)}
            >
              {dataSource.length > 0 ? (
                <div className={classNames(styles.contentWrap)}>
                  <Masonry
                    columns={2}
                    gutter={30}
                    items={dataSource.map((data) => ({
                      key: data.resourceUuid,
                      data: data,
                    }))}
                    itemRender={({ data }) => (
                      <ResourceCard data={data} rows={5} changeData={updateData} />
                    )}
                  />
                  <Pagination
                    align="end"
                    style={{ marginTop: "20px" }}
                    current={params.currentPage}
                    pageSize={params.pageSize}
                    total={total}
                    showSizeChanger={false}
                    showQuickJumper
                    onChange={(page, pageSize) => {
                      setparams({
                        currentPage: page,
                        pageSize: pageSize,
                      });
                    }}
                  />
                </div>
              ) : (
                <div
                  className={classNames(
                    styles.emptyWrap,
                    "flex_box",
                    "align_center",
                    "flex_center",
                  )}
                >
                  <Empty />
                </div>
              )}
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};
export default OpenData;
